import {match} from 'ts-pattern';

import {VehiclePriceChangeDirection} from '../../../../../utils/getVehiclePriceChangeDirection';

type TriangleCoordinates = [number, number][];

const TRIANGLE_RING_HOLE_SCALE = 0.42;

function getScatterTriangleCoordinates(
  cx: number,
  cy: number,
  direction: VehiclePriceChangeDirection,
  size: number
): TriangleCoordinates {
  const baseOffset = size * 0.75;

  return match(direction)
    .with(
      'increased',
      () =>
        [
          [cx, cy - size],
          [cx - size, cy + baseOffset],
          [cx + size, cy + baseOffset],
        ] as TriangleCoordinates
    )
    .with(
      'decreased',
      () =>
        [
          [cx, cy + size],
          [cx - size, cy - baseOffset],
          [cx + size, cy - baseOffset],
        ] as TriangleCoordinates
    )
    .exhaustive();
}

function formatCoordinate(value: number) {
  return Math.round(value * 100) / 100;
}

function coordinatesToPoints(coordinates: TriangleCoordinates) {
  return coordinates.map(([x, y]) => `${formatCoordinate(x)},${formatCoordinate(y)}`).join(' ');
}

function coordinatesToPath(coordinates: TriangleCoordinates) {
  return `M ${coordinates.map(([x, y]) => `${formatCoordinate(x)},${formatCoordinate(y)}`).join(' L ')} Z`;
}

export function getScatterTrianglePoints(
  cx: number,
  cy: number,
  direction: VehiclePriceChangeDirection,
  size: number
) {
  return coordinatesToPoints(getScatterTriangleCoordinates(cx, cy, direction, size));
}

export function getScatterTriangleRingPath(
  cx: number,
  cy: number,
  direction: VehiclePriceChangeDirection,
  size: number
) {
  const outer = getScatterTriangleCoordinates(cx, cy, direction, size);
  const inner = getScatterTriangleCoordinates(cx, cy, direction, size * TRIANGLE_RING_HOLE_SCALE);

  return `${coordinatesToPath(outer)} ${coordinatesToPath(inner)}`;
}
